/**
 * Chromium exposes `performance.memory` (non-standard). Firefox/Safari do not.
 * Values are JS heap only — Blob / GPU texture backing stores may sit outside.
 */
export interface JsHeapSnapshot {
  jsHeapSizeLimit: number;
  totalJSHeapSize: number;
  usedJSHeapSize: number;
}

interface PerformanceMemory {
  jsHeapSizeLimit: number;
  totalJSHeapSize: number;
  usedJSHeapSize: number;
}

interface PerformanceWithMemory extends Performance {
  memory?: PerformanceMemory;
}

export const readJsHeapSnapshot = (): JsHeapSnapshot | null => {
  const memory = (performance as PerformanceWithMemory).memory;
  if (
    memory == null ||
    typeof memory.jsHeapSizeLimit !== "number" ||
    typeof memory.totalJSHeapSize !== "number" ||
    typeof memory.usedJSHeapSize !== "number"
  ) {
    return null;
  }

  return {
    jsHeapSizeLimit: memory.jsHeapSizeLimit,
    totalJSHeapSize: memory.totalJSHeapSize,
    usedJSHeapSize: memory.usedJSHeapSize,
  };
};
